import React from 'react';
import { createRoot } from 'react-dom/client';

import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import { startApp } from './actions/startApp';
import ProductionClient from './components/ProductionClient';
import { store } from './store';

initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((user) => {
  if (user) store.dispatch(startApp());
});

const root = createRoot(document.querySelector('.root')!);
root.render(<ProductionClient reduxStore={store} />);
